import React from 'react';
import 'video-react/dist/video-react.css';
import white_bg from '../../assets/images/white_bg1.png';

import AboutAward from '../../components/AboutAward/AboutAward';
import Demonstration from '../../components/Demonstration/Demonstration';
import Partner from '../../components/Partner/Partner';
import TrendCard from '../../components/TrendCard/TrendCard';

//lottie
import innovation from '../../assets/lottie/innovation/data.json';
import environmentProduction from '../../assets/lottie/environmentProduction/data.json';
import exemplary from '../../assets/lottie/exemplary/data.json';
import DynamicCard from '../../components/DynamicCard/DynamicCard';
import { APPLY_YEAR, APPLY_PERIOD_CHINESE } from '../../utils/config';

import './home.scss';

const Home = () => {
  const attributes = [
    { title: '创新性', lottieData: { data: innovation, assetPath: '' } },
    {
      title: '环保性',
      lottieData: { data: environmentProduction, assetPath: '' },
    },
    { title: '示范性', lottieData: { data: exemplary, assetPath: '' } },
  ];
  const attributesElement = attributes.map((item) => {
    return (
      <div className="attribute" key={item.title}>
        <div className="attribute-lottie">
          <DynamicCard title={item.title} lottieData={item.lottieData} />
        </div>
        <span>{item.title}</span>
      </div>
    );
  });

  return (
    <div className="home" style={{ marginTop: -80 }}>
      <div className="first-container">
        <video className="video-class" muted autoPlay loop src="https://s3plus.meituan.net/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/index.mp4" />
        <div className="first-content">
          <div className="title bold-yahei" style={{ fontWeight: 700, color: '#222', fontSize: 60, lineHeight: '80px' }}>
            <div>
              <span>以科技为引擎</span>
            </div>
            <div>
              <span>共筑绿水青山</span>
            </div>
          </div>
          <div className="content yahei">
            美团青山科技基金是美团发起设立的公益性基金，旨在鼓励更多科研力量投身环保研究，
            <br />
            助力绿色低碳基础科研及技术成果转化，推动行业绿色发展，实现美丽中国愿景蓝图。
          </div>
          <div className="content yahei" style={{ marginTop: 0 }}>
            基金资助方向包括青年科学家公益性奖项和环保科技创新示范项目两大分支。
          </div>
        </div>
      </div>
      <div className="block-container second-container">
        <div className="content video-content">
          <div className="left-content">
            <video autoPlay muted controls width="100%" className="container-video">
              <source src="https://s3plus.sankuai.com/v1/mss_4662117880a641b09d8a16636fb73609/greentech-public/greentechPromotionalVideo.mp4" />
            </video>
          </div>
          <div className="right-content">
            <img src={white_bg} alt="" />
            <TrendCard />
          </div>
        </div>
      </div>
      <div className="third-container block-container">
        <div className="title">
          <span>青山科技奖</span>
          <span className="text-sm">
            {`青山科技奖聚焦绿色、低碳、可持续发展。${APPLY_YEAR}年度，奖项资助在材料科学、化学、化学工程、环境科学、能源科学等学科领域有关键推动作用的青年科研工作者，主要关注绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制四大议题，特别鼓励数智技术与绿色低碳技术的交叉融合。`}
          </span>
        </div>
        <div className="background" />
        <div className="content">
          <AboutAward />
        </div>
      </div>
      <div className="fifth-container schedule-container">
        <div className="schedule-title">{`第${APPLY_PERIOD_CHINESE}届青山科技奖评奖日程`}</div>
        <div className="current-year">
          <div>
            <div className="schedule-content">
              <span className="serial">01</span>
              <span className="content">启动申报</span>
              <span className="date">2026年4月</span>
            </div>
          </div>
          <div className="schedule-content">
            <span className="serial">02</span>
            <span className="content">申报截止</span>
            <span className="date">2026年7月</span>
          </div>
          <div className="schedule-content">
            <span className="serial">03</span>
            <span className="content">启动评审</span>
            <span className="date">2026年8月</span>
          </div>
          <div className="schedule-content">
            <span className="serial">04</span>
            <span className="content">公示评审结果</span>
            <span className="date">2026年11月</span>
          </div>
          <div className="schedule-content">
            <span className="serial">05</span>
            <span className="content">{`公布第${APPLY_PERIOD_CHINESE}届青山科技奖获奖人`}</span>
            <span className="date">2026年12月</span>
          </div>
        </div>
      </div>
      <div className="fourth-container block-container">
        <div className="background"></div>
        <div className="title">
          <div className="left-container">
            <div className={'t-sp'} style={{ marginLeft: '-0.5em' }}>
              “科创中国”美团青山环保科技创新
            </div>
            <div className="t-sp" style={{ marginTop: 0 }}>
              示范项目
            </div>
            <div className="text-sm">
              聚焦绿色创新包装、绿色回收再生、绿色供应链体系三大领域。
              <br />
              通过公开征集具有创新性、环保性、示范性的先进技术和项目，促进一批环保创新科技成果应用落地，形成可复制的示范案例，推进外卖行业绿色低碳循环发展。
            </div>
          </div>
          <div className="right-container">{attributesElement}</div>
        </div>
        <div className="content">
          <Demonstration />
        </div>
      </div>
      {/* <div className='fifth-container schedule-container'>
        <div className='schedule-title'>第二期“科创中国”美团青山环保科技创新示范项目遴选日程</div>
        <div className='current-year'>
          <div>
            <div className='schedule-content'>
              <span className='serial'>01</span>
              <span className='content'>意向征集开始</span>
              <span className='date'>2023.05</span>
            </div>
          </div>
          <div>
            <div className='schedule-content'>
              <span className='serial'>02</span>
              <span className='content'>启动申报</span>
              <span className='date'>2023.09.01</span>
            </div>
          </div>
          <div className='schedule-content'>
            <span className='serial'>03</span>
            <span className='content'>申报截止</span>
            <span className='date'>2023.09.30</span>
          </div>
          <div className='schedule-content'>
            <span className='serial'>04</span>
            <span className='content'>启动评审</span>
            <span className='date'>2023.10</span>
          </div>
          <div className='schedule-content'>
            <span className='serial'>05</span>
            <span className='content'>公布第二期入选项目</span>
            <span className='date'>2023.12</span>
          </div>

        </div>
      </div> */}
      <div className="sixth-container block-container">
        <Partner />
      </div>
    </div>
  );
};

export default Home;
